import { useRef, useEffect }from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import SingleImageUploader from 'src/components/uploads/image-uploader';
import SubmitButton, { useCustomFormik } from 'src/components/formik-helper';
import StringTextField from 'src/components/widgets/string-textfield';
import DateAndTimePicker from 'src/components/widgets/date-time-picker';
import DropdownPlates from 'src/components/dropdown/dropdown-plates';
import DropdownPartners from 'src/components/dropdown/dropdown-partners';
import DropdownPricing from 'src/components/dropdown/dropdown-pricing';
import QuillEditor from 'src/components/quill-editor';
import { getCacheCarPartner } from 'src/utils/cache-data';
import { mergeNoteFromEditor } from 'src/utils/formatters';
import StringUtils from 'src/utils/string-util';
import {
  initialValues,
  validationSchema,
  formatWithCommas,
  handleSubmitted,
} from './formik';

export const DetailForm = ({ item, apiCreate, apiUpdate, apiRemove }) => {
  const editorRef = useRef();

  const formik = useCustomFormik({
    validationSchema: validationSchema(item),

    onSubmit: async (values, helpers) => {
      const mergeValues = mergeNoteFromEditor(values, editorRef, item.note);
      await handleSubmitted(mergeValues, item, apiCreate, apiUpdate, apiRemove);
    },
  });

  useEffect(() => {
    initialValues(formik, item);
    
    if (item) {
      const carId = formik.values?.plateField?.value;
      if(carId){
        const partners = getCacheCarPartner();
        const cache = partners[carId];
        if (cache) {
          const card = cache.xd.cardNumber;
          if(card){
            item.currentCard = card;
            if(!item.cardNumber){
              item.cardNumber = StringUtils.getLastNChars(card, 4);
            }
          }
        }
      }
    } 
  }, [item]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <Card>
        <CardContent sx={{ px: 1, py: 2 }}>
          <Grid container spacing={3} alignItems="flex-start">
            <Grid container spacing={3} xs={12} md={6}>
              <Grid xs={12} md={6}>
                <StringTextField
                  label="Số lượng"
                  name="quantity"
                  formik={formik}
                  onChangeValue={(newValue) => {
                    return formatWithCommas(newValue);
                  }}
                  inputProps={{ maxLength: 6 }}
                  hintValue={item.quantity}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <DropdownPricing
                  name="pricingField"
                  type='xd'
                  formik={formik}
                  hintValue={item.price}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <DropdownPartners
                  name="partnerField"
                  type='xd'
                  formik={formik}
                  hintValue={item.partner?.label}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <StringTextField
                  label="Số thẻ"
                  name="cardField"
                  formik={formik}
                  inputProps={{ 
                    maxLength: 4,
                    onInput: (e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, '');
                    },
                  }}
                  hintValue={item.cardNumber}
                />
              </Grid>

              <Grid xs={6} md={6} sm={6}>
                <DropdownPlates
                  formik={formik}
                  onlyRow={true}
                  hintValue={item.car?.name}
                />
              </Grid>
              
              <Grid xs={6} md={6} sm={6}>
                <DateAndTimePicker
                  label="Ngày tiếp nhiên liệu"
                  name="created"
                  formik={formik}
                  hintValue={item.paidDate}
                />
              </Grid>

              <Grid xs={12}>
                <QuillEditor
                  ref={editorRef}
                  value={item.note}
                />
              </Grid>
            </Grid>
            <Grid xs={12} md={6}>
              <SingleImageUploader formik={formik} />
            </Grid>
            
            <Grid xs={12} md={6} display="flex" 
              sx={{ justifyContent: { xs: 'center', md: 'flex-end' } }}
            >
              <SubmitButton formik={formik} isRemove={item.id > 0 || false} />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </form>
  );
};

DetailForm.propTypes = {
  item: PropTypes.object.isRequired,
  apiCreate: PropTypes.func,
  apiUpdate: PropTypes.func,
  apiRemove: PropTypes.func,
};